/**
 * Plan de entrenamiento — fuente única de verdad.
 *
 * Para editar el plan solo hay que tocar este archivo: la página se construye
 * a partir de estos datos. Los `id` se usan como clave del registro de cargas
 * en localStorage, así que NO deben cambiar una vez usados (si cambias un id,
 * se pierde el historial de ese ejercicio).
 */

const youtube = (query) =>
  `https://www.youtube.com/results?search_query=${encodeURIComponent(query)}`

export const meta = {
  title: 'Plan de fuerza — Roiner',
  stamp: '07:00',
  stampLabel: 'La barra no espera',
  intro:
    '4 días de gimnasio distribuidos para rendir también en pádel, tenis y la portería. Objetivo doble: perder grasa y ganar músculo, sin sacrificar piernas los días de deporte.',
  chips: [
    { label: 'Nivel', value: 'avanzado' },
    { label: 'Duración', value: '60–80 min' },
    { label: 'Frecuencia', value: 'Lun · Mar · Jue · Vie' },
    { label: 'Enfoque', value: 'recomposición corporal' },
  ],
}

export const week = [
  { day: 'LUN', detail: 'Gym 7am · Pádel pm', gym: true, sport: true, target: 'LUN' },
  { day: 'MAR', detail: 'Gym 7am', gym: true, sport: false, target: 'MAR' },
  { day: 'MIÉ', detail: 'Tenis · Fútbol pm', gym: false, sport: true, target: null },
  { day: 'JUE', detail: 'Gym 7am · Fútbol pm', gym: true, sport: true, target: 'JUE' },
  { day: 'VIE', detail: 'Gym 7am', gym: true, sport: false, target: 'VIE' },
  { day: 'SÁB', detail: 'Tenis opcional', gym: false, sport: false, target: null },
  { day: 'DOM', detail: 'Descanso real', gym: false, sport: false, target: null },
]

export const days = [
  {
    id: 'LUN',
    title: 'Empuje — Pecho · Hombro · Tríceps',
    duration: '~70 min',
    restNote: 'Descansos: básicos 2–3 min · accesorios 60–90 s',
    strategy:
      'Cero trabajo de pierna para llegar fresco al pádel de la noche. El press militar baja a 3 series: ya acumulas mucho trabajo por encima de la cabeza entre banca inclinada, saques de tenis y remates de pádel.',
    warmup:
      'Movilidad de hombro con liga, rotadores externos con liga 2×15, flexiones 2×10, series de aproximación en banca.',
    exercises: [
      {
        id: 'lun-press-banca',
        name: 'Press banca plana con barra',
        sets: 4,
        reps: '6–8',
        rest: '2–3 min',
        note: 'Ejercicio principal. Pesado, técnica estricta.',
        video: youtube('press de banca plana con barra tecnica'),
      },
      {
        id: 'lun-press-inclinado-mancuernas',
        name: 'Press inclinado con mancuernas',
        sets: 4,
        reps: '8–10',
        rest: '2 min',
        note: 'Banca a 30°. Baja controlado 2–3 s.',
        video: youtube('press inclinado con mancuernas tecnica'),
      },
      {
        id: 'lun-press-militar',
        name: 'Press militar de pie con barra',
        sets: 3,
        reps: '6–8',
        rest: '2–3 min',
        note: 'Glúteo y core apretados, sin arquear lumbar. Bajado a 3 series para cuidar el hombro.',
        video: youtube('press militar de pie con barra tecnica'),
      },
      {
        id: 'lun-elevaciones-laterales',
        name: 'Elevaciones laterales con mancuernas',
        sets: 4,
        reps: '12–15',
        rest: '60 s',
        note: 'Ligero, sin balanceo. Hombro 3D.',
        video: youtube('elevaciones laterales con mancuernas tecnica'),
      },
      {
        id: 'lun-cruces-polea',
        name: 'Cruces en polea (pecho)',
        sets: 3,
        reps: '12–15',
        rest: '60 s',
        note: 'Aprieta 1 s al cerrar.',
        video: youtube('cruces en polea pecho tecnica'),
      },
      {
        id: 'lun-rotacion-externa',
        name: 'Rotación externa con liga (manguito)',
        sets: 3,
        reps: '15',
        rest: '45 s',
        note: 'Segunda dosis semanal de manguito rotador. Es tu seguro anti-lesión de hombro.',
        video: youtube('rotacion externa con banda hombro manguito rotador'),
      },
      {
        id: 'lun-extension-triceps',
        name: 'Extensión de tríceps en polea',
        sets: 3,
        reps: '10–12',
        rest: '60 s',
        note: 'Codos pegados al cuerpo.',
        video: youtube('extension de triceps en polea tecnica'),
      },
      {
        id: 'lun-press-frances',
        name: 'Press francés con barra Z',
        sets: 3,
        reps: '10–12',
        rest: '90 s',
        note: 'En banca plana, baja a la frente.',
        video: youtube('press frances barra z tecnica'),
      },
    ],
    core: {
      label: 'Anti-extensión',
      time: '8 min',
      note: 'El patrón que sostiene tu lumbar bajo la barra y al estirarte en el aire como portero.',
      exercises: [
        {
          id: 'lun-core-ab-wheel',
          name: 'Rollout con barra olímpica (desde rodillas)',
          sets: 3,
          reps: '8–10',
          rest: '60 s',
          note: 'Barra en el suelo con discos pequeños, rueda hacia adelante. Costillas abajo, glúteo apretado: si la lumbar se arquea, acorta el recorrido.',
          video: youtube('barbell rollout con barra desde rodillas tecnica'),
        },
        {
          id: 'lun-core-hollow',
          name: 'Hollow hold',
          sets: 3,
          reps: '30 s',
          rest: '45 s',
          note: 'Lumbar pegada al suelo. Si se despega, sube las piernas.',
          video: youtube('hollow hold ejercicio tecnica'),
        },
      ],
    },
  },

  {
    id: 'MAR',
    title: 'Tracción — Espalda · Bíceps + Bloque de pierna',
    duration: '~80 min',
    restNote: 'Descansos: básicos 2–3 min · accesorios 60–90 s',
    strategy:
      'Espalda fuerte y hombro sano = más potencia y menos lesiones en tenis y portería. El bloque corto de pierna (glúteo + aductor) reparte el volumen que antes se acumulaba todo el viernes, sin comprometer el tenis del miércoles.',
    warmup:
      'Band pull-aparts 2×15, colgarse de la barra 2×20 s, jalón ligero 2×12, movilidad de cadera.',
    exercises: [
      {
        id: 'mar-dominadas',
        name: 'Dominadas (o jalón al pecho pesado)',
        sets: 4,
        reps: '6–10',
        rest: '2–3 min',
        note: 'Si superas 10, agrega lastre.',
        video: youtube('dominadas tecnica correcta'),
      },
      {
        id: 'mar-remo-t',
        name: 'Remo T',
        sets: 4,
        reps: '8–10',
        rest: '2 min',
        note: 'Torso a 45°, tira hacia el ombligo.',
        video: youtube('remo t con barra tecnica'),
      },
      {
        id: 'mar-remo-mancuerna',
        name: 'Remo con mancuerna a una mano',
        sets: 3,
        reps: '10–12',
        rest: '90 s',
        note: 'Apoyo en banca, sin girar el torso.',
        video: youtube('remo con mancuerna a una mano tecnica'),
      },
      {
        id: 'mar-face-pull',
        name: 'Face pull en polea',
        sets: 3,
        reps: '15',
        rest: '60 s',
        note: 'Clave para hombros de tenista/portero.',
        video: youtube('face pull en polea tecnica'),
      },
      {
        id: 'mar-curl-z',
        name: 'Curl con barra Z',
        sets: 3,
        reps: '8–10',
        rest: '90 s',
        note: 'Codos fijos, sin impulso.',
        video: youtube('curl de biceps con barra z tecnica'),
      },
      {
        id: 'mar-curl-martillo',
        name: 'Curl martillo con mancuernas',
        sets: 3,
        reps: '10–12',
        rest: '60 s',
        note: 'Antebrazo fuerte para el agarre en tenis.',
        video: youtube('curl martillo con mancuernas tecnica'),
      },
      {
        id: 'mar-hip-thrust',
        name: 'Hip thrust con barra',
        sets: 3,
        reps: '8–10',
        rest: '90 s',
        note: 'Movido desde el viernes. Poco DOMS y no compromete el sprint del miércoles. Aprieta 2 s arriba.',
        video: youtube('hip thrust con barra tecnica'),
      },
      {
        id: 'mar-copenhagen',
        name: 'Copenhagen plank (aductores)',
        sets: 3,
        reps: '20 s/lado',
        rest: '45 s',
        note: 'Sustituye a la máquina de aducción: es lo que de verdad protege la ingle en cambios de dirección. Empieza con la rodilla apoyada.',
        video: youtube('copenhagen plank aductores progresion tecnica'),
      },
    ],
    core: {
      label: 'Anti-rotación',
      time: '8 min',
      note: 'Aguantar la rotación que no quieres es lo que te deja generar la que sí quieres en el golpe de derecha.',
      exercises: [
        {
          id: 'mar-core-pallof',
          name: 'Pallof press con liga',
          sets: 3,
          reps: '12/lado',
          rest: '45 s',
          note: 'Que la cadera no gire ni un grado. Cuanto más lejos del anclaje, más difícil.',
          video: youtube('pallof press con banda tecnica'),
        },
        {
          id: 'mar-core-plancha-disco',
          name: 'Plancha con disco en la espalda',
          sets: 3,
          reps: '45 s',
          rest: '45 s',
          note: 'Sube el disco cuando aguantes los 45 s sin que caiga la cadera.',
          video: youtube('plancha abdominal con peso tecnica'),
        },
      ],
    },
  },

  {
    id: 'JUE',
    title: 'Torso Fuerza + Potencia',
    duration: '~70 min',
    restNote: 'Descansos: básicos 3 min · accesorios 60–90 s',
    strategy:
      'Atajas en la noche. Fuerza pesada de torso + explosividad con kettlebell, y las piernas casi sin tocar para volar bajo los tres palos.',
    warmup:
      'Movilidad de hombro y cadera, swings ligeros con kettlebell 2×10, aproximación en banca inclinada.',
    exercises: [
      {
        id: 'jue-press-inclinado-barra',
        name: 'Press banca inclinado con barra',
        sets: 4,
        reps: '5–6',
        rest: '3 min',
        note: 'El día más pesado de empuje. Deja 1 rep en reserva.',
        video: youtube('press de banca inclinado con barra tecnica'),
      },
      {
        id: 'jue-jalon-cerrado',
        name: 'Jalón al pecho agarre cerrado',
        sets: 4,
        reps: '8–10',
        rest: '2 min',
        note: 'Estira arriba, aprieta abajo.',
        video: youtube('jalon al pecho agarre cerrado tecnica'),
      },
      {
        id: 'jue-press-hombro-mancuernas',
        name: 'Press de hombro con mancuernas sentado',
        sets: 3,
        reps: '8–10',
        rest: '2 min',
        note: 'Respaldo a 80°. Si el hombro viene cargado del pádel, sáltalo: ya tienes press militar el lunes.',
        video: youtube('press de hombro con mancuernas sentado tecnica'),
      },
      {
        id: 'jue-kettlebell-swing',
        name: 'Kettlebell swing',
        sets: 4,
        reps: '10',
        rest: '90 s',
        note: 'Explosivo desde la cadera. Potencia sin fatiga muscular.',
        video: youtube('kettlebell swing tecnica correcta'),
      },
      {
        id: 'jue-remo-polea',
        name: 'Remo en polea sentado',
        sets: 3,
        reps: '10–12',
        rest: '90 s',
        note: 'Pecho arriba, escápulas juntas.',
        video: youtube('remo en polea sentado tecnica'),
      },
      {
        id: 'jue-superserie-brazo',
        name: 'Superserie: curl en máquina + extensión de tríceps',
        sets: 3,
        reps: '10 + 10',
        rest: '75 s',
        note: 'Sin descanso entre los dos ejercicios.',
        video: youtube('superserie biceps triceps tecnica'),
      },
    ],
    core: {
      label: 'Rotación potente',
      time: '10 min',
      note: 'Aquí sí buscas producir rotación rápida: saque de tenis, remate de pádel y despeje. Explosivo en la ida, controlado en la vuelta.',
      exercises: [
        {
          id: 'jue-core-lenador',
          name: 'Leñador en polea (alto a bajo)',
          sets: 3,
          reps: '10/lado',
          rest: '45 s',
          note: 'Gira desde la cadera y el tronco, no solo con los brazos.',
          video: youtube('leñador en polea woodchopper tecnica'),
        },
        {
          id: 'jue-core-lanzamiento-balon',
          name: 'Rotación explosiva en polea (cable scoop)',
          sets: 3,
          reps: '8/lado',
          rest: '45 s',
          note: 'Lo más explosivo del día: peso moderado y máxima velocidad en la ida, vuelta controlada. Transfiere directo al saque de tenis.',
          video: youtube('cable scoop toss rotacion explosiva polea tecnica'),
        },
        {
          id: 'jue-core-dead-bug',
          name: 'Dead bug',
          sets: 3,
          reps: '10/lado',
          rest: '45 s',
          note: 'Lumbar pegada al suelo todo el tiempo. Cierra el bloque enfriando el sistema.',
          video: youtube('dead bug ejercicio tecnica'),
        },
      ],
    },
    finisher: '2 series de flexiones al fallo, 60 s de descanso entre ellas.',
  },

  {
    id: 'VIE',
    title: 'Pierna Completa + Potencia',
    duration: '~75 min',
    restNote: 'Descansos: básicos 3 min · accesorios 60–90 s',
    strategy:
      'Recortado de 9 a 7 ejercicios: 21 series de calidad rinden más que 29 arrastrando fatiga. El glúteo y los aductores se movieron al martes. Tienes sábado y domingo para recuperar.',
    warmup:
      'Movilidad de cadera y tobillo, sentadilla con peso corporal 2×15, monster walks con liga 2×12, aproximación en sentadilla.',
    exercises: [
      {
        id: 'vie-pliometria',
        name: 'Salto al cajón / lateral bounds',
        sets: 3,
        reps: '5',
        rest: '90 s',
        note: 'PRIMERO, con las piernas frescas. No es cardio: busca máxima altura y aterrizaje silencioso. Es el primer paso en pádel y la estirada de portero.',
        video: youtube('box jump y lateral bound pliometria tecnica'),
      },
      {
        id: 'vie-sentadilla',
        name: 'Sentadilla con barra (rack)',
        sets: 4,
        reps: '5–8',
        rest: '3 min',
        note: 'El rey. Profundidad completa con control.',
        video: youtube('sentadilla con barra tecnica correcta'),
      },
      {
        id: 'vie-peso-muerto-rumano',
        name: 'Peso muerto rumano con barra',
        sets: 4,
        reps: '8–10',
        rest: '2–3 min',
        note: 'Cadera atrás, espalda neutra. Isquios de acero = menos desgarros corriendo.',
        video: youtube('peso muerto rumano con barra tecnica'),
      },
      {
        id: 'vie-hack-squat',
        name: 'Sentadilla hack',
        sets: 3,
        reps: '8–10',
        rest: '2 min',
        note: 'Cuádriceps sin cargar la espalda.',
        video: youtube('sentadilla hack maquina tecnica'),
      },
      {
        id: 'vie-bulgara',
        name: 'Zancada búlgara con mancuernas',
        sets: 3,
        reps: '10/pierna',
        rest: '90 s',
        note: 'Unilateral: equilibrio y empuje para el sprint.',
        video: youtube('zancada bulgara con mancuernas tecnica'),
      },
      {
        id: 'vie-nordic-curl',
        name: 'Nordic curl (isquios excéntrico)',
        sets: 3,
        reps: '5',
        rest: '90 s',
        note: 'EL ejercicio anti-desgarro de isquio: reduce el riesgo a la mitad en deportes de sprint. Setup en tu gym: pies anclados en la máquina de lumbares o bajo una barra cargada en el rack. Baja lo más lento que puedas y empuja con las manos al llegar abajo. Las 2 primeras semanas haz solo 2×4: el DOMS inicial es brutal.',
        video: youtube('nordic hamstring curl progresion principiantes'),
      },
      {
        id: 'vie-gemelos',
        name: 'Elevación de talones',
        sets: 4,
        reps: '12–15',
        rest: '45 s',
        note: 'Pausa abajo, estira el gemelo. Tobillo fuerte = menos esguinces.',
        video: youtube('elevacion de talones gemelos tecnica'),
      },
    ],
    core: {
      label: 'Anti-flexión lateral + carga',
      time: '8 min',
      note: 'El patrón que falta en casi todos los planes: aguantar carga asimétrica. Es lo que estabiliza tu tronco cuando frenas en seco con el peso a un lado.',
      exercises: [
        {
          id: 'vie-core-suitcase-carry',
          name: 'Paseo del granjero a una mano (suitcase carry)',
          sets: 3,
          reps: '30 m/lado',
          rest: '60 s',
          note: 'Pesado. Hombros nivelados, sin inclinarte. Bonus: agarre para el tenis.',
          video: youtube('suitcase carry paseo granjero una mano tecnica'),
        },
        {
          id: 'vie-core-plancha-lateral',
          name: 'Plancha lateral con elevación de cadera',
          sets: 3,
          reps: '10/lado',
          rest: '45 s',
          note: 'Cuadrado lumbar y oblicuo. Cuerpo en línea recta, sin rotar.',
          video: youtube('plancha lateral con elevacion de cadera tecnica'),
        },
      ],
    },
  },
]

export const rules = [
  {
    title: 'Doble progresión',
    body: 'Cuando completes el <b>tope de reps en todas las series</b> (ej. 4×8 en banca), sube el peso 2.5–5 kg la siguiente semana y vuelve a construir. Para eso registras las cargas aquí.',
  },
  {
    title: 'Intensidad real',
    body: 'Termina cada serie a <b>1–2 reps del fallo</b>. Si podrías hacer 5 más, el peso está bajo y no habrá estímulo.',
  },
  {
    title: 'Cardio ya lo tienes',
    body: 'Pádel, tenis, fútbol y correr <b>son tu cardio</b>. No agregues más en el gym: ahí el trabajo es fuerza pura.',
  },
  {
    title: 'Core en los 4 patrones',
    body: 'Anti-extensión, anti-rotación, anti-flexión lateral y rotación potente: uno por día. <b>Un core que resiste</b> transfiere más al deporte que mil abdominales.',
  },
  {
    title: 'Descarga',
    body: 'Cada <b>6–8 semanas</b>, una semana con el 60% del peso habitual. El músculo crece cuando recuperas.',
  },
  {
    title: 'Sueño',
    body: '<b>7–8 horas.</b> Con doble sesión (gym AM + deporte PM) dormir poco frena la pérdida de grasa y la ganancia muscular.',
  },
  {
    title: 'Proteína diaria',
    body: 'En déficit apunta al rango alto: <b>2.0–2.4 g por kg</b> de peso corporal al día, repartida en 3–4 comidas. Es lo que protege el músculo mientras pierdes grasa.',
  },
  {
    title: 'Señal de alarma',
    body: 'Si <b>las cargas bajan 2 semanas seguidas</b>, no es falta de ganas: comes poco, duermes poco o el déficit es agresivo. Ajusta antes de estancarte.',
  },
]

export const nutrition = [
  {
    number: '01',
    title: '¿Entrenar en ayunas o comer algo?',
    intro:
      'Entrenar totalmente en ayunas es viable, pero con tu volumen (gym pesado en la mañana + deporte en la noche) <b>rendirás más con un carbohidrato rápido antes</b>. Más rendimiento = más estímulo = más músculo, y eso también acelera la pérdida de grasa.',
    items: [
      '<b>20–40 min antes:</b> 1 plátano, o pan con miel, o 2–3 dátiles',
      '<b>Café solo:</b> excelente pre-entreno natural (opcional)',
      '<b>Si toleras más:</b> agrega un batido de proteína (20–30 g)',
      '<b>Siempre:</b> 1–2 vasos de agua al despertar',
      '<b>Después de entrenar:</b> desayuno completo con 30–40 g de proteína + carbohidratos, dentro de las 2 horas',
      '<b>2–3 h antes del deporte pm:</b> comida con carbohidrato; llegar vacío a la noche es la mejor forma de romperte algo',
    ],
    verdict:
      'Come algo ligero. Si un día prefieres ayunas, hazlo, pero baja un punto la expectativa de cargas ese día.',
  },
  {
    number: '02',
    title: 'Creatina en ayunas',
    intro:
      '<b>Sí, sin problema.</b> La creatina funciona por saturación muscular acumulada, no por el momento en que la tomas. Tomarla en ayunas no reduce su efecto ni causa molestias en la mayoría de personas.',
    items: [
      '<b>Dosis:</b> 3–5 g de monohidrato de creatina al día',
      '<b>Cuándo:</b> cualquier hora; lo único que importa es <b>tomarla todos los días</b>, incluso los que no entrenas',
      '<b>Carga:</b> no es necesaria; en 3–4 semanas saturas igual',
      '<b>Ciclos:</b> no hace falta ciclarla',
      '<b>Agua:</b> tómala con un vaso grande y mantente bien hidratado en el día',
      '<b>Bonus:</b> mejora sprints repetidos: te sirve en fútbol, pádel y tenis',
    ],
    verdict:
      'Tómala en ayunas con tu agua de la mañana y olvídate del timing. La constancia es todo. (Es segura en personas sanas; si tienes alguna condición renal, consúltalo con tu médico.)',
  },
]

/** Todos los ejercicios de un día, incluido el bloque de core. */
export const allExercises = (day) => [...day.exercises, ...(day.core?.exercises || [])]
